import Link from "next/link";
import SectionHeader from "@/components/ui/section-header";
import UseCasesGrid from "@/components/sections/shared/use-cases-grid";
import { ROUTES } from "@/lib/constants";
import { RESIDENTIAL_USE_CASES } from "./data";

export default function ResidentialUseCases() {
  return (
    <section
      id="residential-use-cases"
      className="py-section border-border border-b"
      aria-labelledby="residential-use-cases-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 max-w-2xl">
          <SectionHeader
            eyebrow="Use Cases"
            id="residential-use-cases-heading"
            heading="Residential proxies for web scraping and data collection"
            body="The right IP, from the right location, for every workflow that depends on reliable access."
          />
        </div>

        <UseCasesGrid items={RESIDENTIAL_USE_CASES} />

        <p className="text-muted-foreground mt-8 text-sm leading-relaxed">
          Not sure this is the right fit?{" "}
          <Link
            href={ROUTES.useCases}
            className="text-foreground decoration-foreground/30 hover:decoration-foreground underline underline-offset-4"
          >
            Compare proxy workflows across every use case
          </Link>
          .
        </p>
      </div>
    </section>
  );
}
